import * as Yup from 'yup';
import { DictZipCode } from '@models';

export function useValidationSchema() {
  return Yup.object<DictZipCode>().shape({
    code: Yup.string().nullable().required(),
    name: Yup.string().nullable().required(),
  });
}
